import { useState } from "react";
import { Button, Table, Text } from "rizzui";
import { TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/table/components/Table";
import { FaWind } from "react-icons/fa";
import { age, distanceToAero, flightType, rainOptions, sex, visibilitySelector, windDirectionsSpanish, windSpeed, yesNoSelector } from "../../../utils/SelectorMapping";
import { formatCensusLineObservations, formatRiskDetectedLabel } from "../../../utils/censusLineUtils";

interface RowDropdownProps {
    row: any;
}

const CensusLinesDropdown: React.FC<RowDropdownProps> = ({ row }) => {

    // STATES

    const censusLines = row?.census_lines || [];
    const [shown, setShown] = useState(5);
    const linesSlice = censusLines.slice(0, shown);

    // RENDER

    return (
        <>
            <Table className="max-h-table text-[9px] overflow-x-auto p-0 bg-transparent">
                <TableHeader>
                    <TableRow>
                        <TableHead className="col-1 !text-[9px]">Census Min</TableHead>
                        <TableHead className="col-1 !text-[9px]">Viento</TableHead>
                        <TableHead className="col-1 !text-[9px]">Lluvia</TableHead>
                        <TableHead className="col-1 !text-[9px]">Visibilidad</TableHead>
                        <TableHead className="col-1 !text-[9px]">Especies</TableHead>
                        <TableHead className="col-1 !text-[9px]">N_IND</TableHead>
                        <TableHead className="col-1 !text-[9px]">Sexo</TableHead>
                        <TableHead className="col-1 !text-[9px]">Edad</TableHead>
                        <TableHead className="col-1 !text-[9px]">Aero</TableHead>
                        <TableHead className="col-1 !text-[9px]">DIST. AERO</TableHead>
                        <TableHead className="col-1 !text-[9px]">DIR ORIGEN</TableHead>
                        <TableHead className="col-1 !text-[9px]">DIR DEST</TableHead>
                        <TableHead className="col-1 !text-[9px]">VUELO</TableHead>
                        <TableHead className="col-1 !text-[9px]">REACC</TableHead>
                        <TableHead className="col-1 !text-[9px]">AERO ON</TableHead>
                        <TableHead className="col-1 !text-[9px]">RIESGO</TableHead>
                        <TableHead className="col-1 !text-[9px]">OBSERVACIONES</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {linesSlice.map((line: any, index: number) => (
                        <TableRow key={index}>
                            <TableCell>
                                {line.censusMin || '-'}
                            </TableCell>
                            <TableCell>
                                <div className="flex flex-col gap-2">
                                    <Text className="text-center capitalize flex items-center">
                                        <FaWind className="h-2 w-2 me-1 text-primary" size={20} />
                                        {windDirectionsSpanish.find((item) => item.value == line.wind_direction)?.label || '-'},
                                    </Text>
                                    <Text className="text-center font-bold text-gray-500">
                                        {windSpeed.find((item) => item.value == line.wind_speed)?.label.split('-')[1].trim() || '-'}
                                    </Text>
                                </div>
                            </TableCell>
                            <TableCell>
                                {rainOptions.find(option => option.value == line?.rain)?.label || "N/A"}
                            </TableCell>
                            <TableCell>
                                {visibilitySelector.find(option => option.value == line?.visibility)?.label || "N/A"}
                            </TableCell>
                            <TableCell>
                                <div className="italic">
                                    {line.speciesScientificName || '-'}
                                </div>
                            </TableCell>
                            <TableCell>
                                {line?.num_individuals || '-'}
                            </TableCell>
                            <TableCell>
                                {sex.find(option => option.value == line?.sex)?.label || '-'}
                            </TableCell>
                            <TableCell>
                                {age.find(option => option.value == line?.age)?.label || '-'}
                            </TableCell>
                            <TableCell>
                                {line?.windTurbine || '-'}
                            </TableCell>
                            <TableCell>
                                {distanceToAero.find(option => option.value == line?.distance_to_aero)?.label || '-'}
                            </TableCell>
                            <TableCell>
                                {windDirectionsSpanish.find((item) => item.value == line.dirOrigen)?.label || '-'}
                            </TableCell>
                            <TableCell>
                                {windDirectionsSpanish.find((item) => item.value == line.dirDest)?.label || '-'}
                            </TableCell>
                            <TableCell>
                                {flightType.find(option => option.value == line?.flight_type)?.label || '-'}
                            </TableCell>
                            <TableCell>
                                {yesNoSelector.find(option => option.value == line.reacc)?.label || 'N/A'}
                            </TableCell>
                            <TableCell>
                                {line?.aero_status.charAt(0).toUpperCase() + line?.aero_status.slice(1) || '-'}
                            </TableCell>
                            <TableCell>
                                {formatRiskDetectedLabel(line.risk_detected)}
                            </TableCell>
                            <TableCell>
                                <Text className="whitespace-pre-wrap break-words">
                                    {formatCensusLineObservations(line)}
                                </Text>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {shown < censusLines.length && (
                <Button
                    variant="solid"
                    color="primary"
                    className="mt-3 w-full"
                    onClick={() => setShown(shown + 5)}
                >
                    Ver más
                </Button>
            )}
        </>
    );
};

export default CensusLinesDropdown;
